import { useEffect } from 'react';
import useIsFirstMount from '../../../../../react-hooks/useIsFirsMount';
const useValueChange = ({ selectedValue, hasValueChanged, setValue, name, onChange }) => {
    const isFirstMount = useIsFirstMount();
    useEffect(() => {
        if (selectedValue && hasValueChanged) {
            setValue(name, selectedValue);
            onChange && !isFirstMount && onChange(selectedValue);
        }
    }, [hasValueChanged, selectedValue, setValue, name, isFirstMount, onChange]);
};
export default useValueChange;
//# sourceMappingURL=useValueChange.js.map